import ContentZone from './ContentZone';

export default ContentZone;
